import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDashboard } from "./adminApi";

const EMPTY_STATS = {
  total: 0,
  drafts: 0,
  published_this_month: 0,
};

function formattedDate(value) {
  if (!value) return "-";

  return new Date(value).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

function AdminDashboard() {
  const [stats, setStats] = useState(EMPTY_STATS);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    async function loadDashboard() {
      try {
        const response = await getDashboard();
        setStats(response.stats || EMPTY_STATS);
        setRecentBlogs(response.recent_blogs || []);
      } catch (error) {
        setError(error.message || "Unable to load dashboard.");
      } finally {
        setIsLoading(false);
      }
    }

    loadDashboard();
  }, []);

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <p className="eyebrow">Overview</p>
          <h2>Dashboard</h2>
        </div>
        <Link to="/admin/add-blog" className="admin-button secondary">
          + New Blog
        </Link>
      </div>

      {error && <p className="auth-error">{error}</p>}

      <div className="card-grid">
        <article className="info-card">
          <div className="info-card-top">
            <span className="info-card-label">Total Blogs</span>
            <span className="info-card-tag">Live + Draft</span>
          </div>
          <div className="info-card-value">{isLoading ? "..." : stats.total}</div>
          <p className="info-card-copy">
            All published and draft posts in your blog collection.
          </p>
        </article>

        <article className="info-card accent-card">
          <div className="info-card-top">
            <span className="info-card-label">Drafts Waiting</span>
          </div>
          <div className="info-card-value">{isLoading ? "..." : stats.drafts}</div>
          <p className="info-card-copy">Draft articles that are ready for review.</p>
        </article>

        <article className="info-card accent-card alt">
          <div className="info-card-top">
            <span className="info-card-label">Published This Month</span>
          </div>
          <div className="info-card-value">
            {isLoading ? "..." : stats.published_this_month}
          </div>
          <p className="info-card-copy">Recent content published this month.</p>
        </article>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">
          <div>
            <p className="eyebrow">Recent Entries</p>
            <h3>Recent Blogs</h3>
          </div>
          <Link to="/admin/view-blogs" className="text-link">
            View all blogs
          </Link>
        </div>

        <div className="table-scroll">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Blog Title</th>
                <th>Publish Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="3">Loading dashboard...</td>
                </tr>
              ) : recentBlogs.length > 0 ? (
                recentBlogs.map((blog) => (
                  <tr key={blog.id}>
                    <td>{blog.title}</td>
                    <td>{formattedDate(blog.published_at || blog.created_at)}</td>
                    <td>
                      <span className={`status-badge ${blog.status.toLowerCase()}`}>
                        {blog.status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No blogs found yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
